/***
 * Created on 2023/8/10
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";

function ChangeSuccessDialog(props) {
    const { t } = useTranslation();

    const onSubmit = () => {
        const url = new URLSearchParams(location.search);
        if (url.has('state')) {
            const state_url = new URLSearchParams(url.get('state'));
            location.pathname = '/signin'
            return;
            // if (state_url.has('redirect_uri')) {
            //     const new_url = new URL(state_url.get('redirect_uri'));
            //     new_url.searchParams.append('statue', 'signed_out');
            //     location.href = new_url.toString();
            //     return;
            // }
        }
        location.href = '/signin';
    }

    return (
        <ModalDialog {...props} title={t('@Your password is changed@')} submitAction={onSubmit} submitText={t('@Sign in again@')} hideCancel={true}>
            <div className="dialog-content">
                <p>
                    {t('@Please sign in your QNAP ID on all of your browsers, QNAP mobile apps, and KoiBot again.@')}
                </p>
            </div>

        </ModalDialog>
    );
}

export default ChangeSuccessDialog;